export default "__VITE_ASSET__DgOLkPGw__"